import { render } from "./ArchiveConfirmModal.vue?vue&type=template&id=fda76df0"
import script from "./ArchiveConfirmModal.vue?vue&type=script&lang=js"
export * from "./ArchiveConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__